import get from 'lodash.get';
import { config } from '@yola/ws-sdk';
import getIsB2C from './is-b2c';

const getCheckoutserviceUrl = (rootState) => {
  const cfg = config.selectors.getConfig(rootState);

  if (getIsB2C(rootState)) {
    return get(cfg, 'common.checkoutservice.url', '');
  }

  return get(cfg, 'common.checkoutservice.wl_url', '');
};

export default getCheckoutserviceUrl;
